export type ParsedQ = qs.ParsedQs[keyof qs.ParsedQs];

/**
 * Get the first value of a query parameter.
 *
 * If a query parameter is specified more than once qs will parse it as an array.
 * - `qs.parse('a=foo').a === 'foo'`
 * - `qs.parse('a=foo&a=bar&a=baz').a === ['foo', 'bar', 'baz']`
 * - `firstValue(qs.parse('a=foo').a) === 'foo'`
 * - `firstValue(qs.parse('a=foo&a=bar&a=baz').a) === 'foo'`
 */
export function firstValue(x: ParsedQ) {
	if (typeof x === 'string') {
		return x;
	} else if (Array.isArray(x) && typeof x?.[0] === 'string') {
		return x[0];
	}
}

export function pathHasPrefix(pathname: string, prefix: string): boolean {
	return pathname === prefix || pathname.startsWith(prefix + '/');
}
